import { get } from 'lodash';

export const selectedUserIdSelector = (state) => get(state, ['user', 'selectedUserId']);
export const userListSelector = (state) => get(state, ['user', 'userList']);
